import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import NoSsr from "@material-ui/core/NoSsr";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: "flex",
    padding: 0,
    cursor: "pointer",
    height: 50,
    paddingLeft: 15,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    overflow:"auto",
    flex: 1,
    alignItems: "center",
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: "absolute",
    fontSize: 16,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
  notchedOutlineError: {
    borderColor: "red !important",
  },
  notchedOutline: {
    borderColor: "#a6a6a6 !important",
  },
  
  
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        classes: {
          notchedOutline: !!props.selectProps.isError
            ? props.selectProps.classes.notchedOutlineError
            : props.selectProps.classes.notchedOutline,
        },
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
      margin="normal"
      variant="outlined"
    />

    // <TextField
    //   fullWidth
    //   InputProps={{
    //     inputComponent,
    //     inputProps: {
    //       className: props.selectProps.classes.input,
    //       inputRef: props.innerRef,
    //       children: props.children,
    //       ...props.innerProps
    //     }
    //   }}
    //   {...props.selectProps.textFieldProps}
    // />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        whiteSpace:"pre-wrap",
        textTransform:"uppercase",
      }}
      {...props.innerProps}
    >
      {props.children}
      
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer} >
      {props.children}
    </div>
  );
}

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
      style={{zIndex:"9999"}}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class IntegrationReactSelect extends React.Component {
  state = {
    single: null,
  };

  render() {
    const { classes, theme } = this.props;

    const selectStyles = {
      input: (base) => ({
        ...base,
        color: theme.palette.text.primary,
        
        cursor: "pointer",
        "& input": {
          font: "inherit",
        },
      }),
    };

    return (
      <div className={classes.root}>
        <NoSsr>
          <ReactSelect
            isDisabled={this.props.disabled}
            ref={this.props.inputRef}
            classes={classes}
            styles={selectStyles}
            options={this.props.suggestions}
            components={components}
            value={this.props.value}
            onChange={this.props.handleChange}
            placeholder={this.props.placeholder}
            isClearable
            onKeyDown={this.props.onKeyDown}
            isError={this.props.isError}
          />
          <div
            style={{
              color: "red",
              fontFamily: "Rubik-Italic",
              
            }}
          >
            {!!this.props.errorMessage ? this.props.errorMessage : ""}
          </div>
        </NoSsr>
      </div>
    );
  }
}

IntegrationReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(IntegrationReactSelect);
